const getUrl = (metric, scenario, country) => {
  const metricString = metric.replace(/\s/g, "+");
  const scenarioString = scenario.replace(/\s/g, "+");
  const countryString = country.replace(/\s/g, "+");

  const url = `https://ember-data-api-scg3n.ondigitalocean.app/ember/euromod_2022.json?_sort=rowid&country_name__exact=${countryString}&metric__exact=${metricString}&scenario__exact=${scenarioString}&_shape=array`;

  return url;
};

export default getUrl;
